
//STYLES
import './Search.css'
import ParagaphsParser from '../../../components/misc/ParagaphsParser'

export default function Search(  {tasks, cat}  ) {

  return (
    <div className='page-container shadowed search-page'>
      <h1>Search in tasks</h1>
      <p>This still has to come Baby !</p>
      <p>En attendant, voici l'ensemble des tâches, classées par Catégories</p>
      {cat && cat.map( c => (
        <div key={c.id}>
          <h2>{c.catName}</h2>
          <ParagaphsParser paragraphs={c.desc} />
          { tasks && tasks.map( t => {
            if (t.catId === c.id) {
              return (
                <div key={t.id}>
                <h3>{t.title}</h3>
                <div className="task-desc">
                <ParagaphsParser paragraphs={t?.paragraphs}/>
                </div>
                </div>
              )
            } else { return <></>}
          })}
        </div>
      ))}
    </div>
  )
}
